interface TrialBannerProps {
  subscriptionStatus: string | null
  trialDaysRemaining: number | null
  onContact: () => void
}

export default function TrialBanner({
  subscriptionStatus,
  trialDaysRemaining,
  onContact,
}: TrialBannerProps) {
  if (subscriptionStatus !== 'trialing' || trialDaysRemaining === null) {
    return null
  }

  let bannerClass = 'bg-blue-50 text-blue-900 border-blue-200'
  let message = `${trialDaysRemaining} days remaining in your trial`

  if (trialDaysRemaining <= 7) {
    bannerClass = 'bg-red-50 text-red-900 border-red-200'
    message = `${trialDaysRemaining} days remaining — contact us to upgrade`
  } else if (trialDaysRemaining <= 14) {
    bannerClass = 'bg-yellow-50 text-yellow-900 border-yellow-200'
    message = `${trialDaysRemaining} days remaining in your trial`
  }

  return (
    <div role="status" className={`border-b px-4 py-2 flex items-center justify-between text-sm ${bannerClass}`}>
      <span>{message}</span>
      <button
        type="button"
        onClick={onContact}
        className="px-3 py-1 rounded text-xs font-medium bg-white hover:bg-gray-50 border border-current"
      >
        Contact sales
      </button>
    </div>
  )
}
